import Http from 'utils/http/index'

export const attemptLogin = (credentials) => {
    return Http
        .post('/login', credentials)
}

export const refreshStore = () => {
    return Http
        .get('/refresh-store')
}

export const refreshProfile = () => {
    return Http
        .get('/refresh-profile')
}

export const doLogout = () => {
    return Http
        .post('/logout')
}

export const sendEmailResetPassword = (payload) => {
    return Http
        .post('/forgot-password', payload)
}

export const resetPassword = (payload) => {
    return Http
        .post('/password-recover', payload)
}

export const memberActivate = (payload) => {
    return Http
        .post('/member-activate', payload)
}



// WEBPACK FOOTER //
// ./src/services/auth.js